/**
 * @file: useDeliveryCheckUserPicker.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { useOrgMemberPicker } from '@euler/app/flows/task/functions';
import { useDeliveryCheckContext } from '@euler/app/flows/task/functions/task-detail/delivery-check/DeliveryCheckContext';
import { OrgMember } from '@euler/model/entity';
import { useBehaviorSubject, usePersistFn } from '@euler/utils/hooks';

export const useDeliveryCheckUserPicker = () => {
  const { manager } = useDeliveryCheckContext();

  const [staged] = useBehaviorSubject(manager.staged$);

  const onChange = usePersistFn((tech: OrgMember) => {
    manager.produce(draft => {
      draft.technicianId = tech.id;
      draft.technicianName = tech.name;
    });
  });

  return useOrgMemberPicker({ currentMemberId: staged.technicianId, onChange });
};
